export const enum RowColor {
  gray = "GRAY",
  white = "WHITE",
}
